import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn } from '../../services/auth/authService';
import Button from '../../components/shared/Button';
import PlanZIcon from '../../components/shared/PlanZIcon';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await signIn(email, password);
            navigate('/');
        } catch (err) {
            setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center" style={{
            minHeight: '100vh',
            background: '#030303', // Force solid dark background
            position: 'relative',
            fontFamily: 'var(--font-primary)',
            color: 'white'
        }}>
            {/* Arka Plan Dekorasyonu */}
            <div style={{ position: 'absolute', top: '5%', left: '5%', width: '40%', height: '40%', background: 'radial-gradient(circle, rgba(37,99,235,0.08) 0%, transparent 70%)', filter: 'blur(60px)' }}></div>
            <div style={{ position: 'absolute', bottom: '5%', right: '5%', width: '50%', height: '50%', background: 'radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 70%)', filter: 'blur(80px)' }}></div>

            <div className="card" style={{
                width: '100%',
                maxWidth: '420px',
                padding: '40px',
                background: '#0c0c0c', // Force solid dark card background
                border: '1px solid rgba(255, 255, 255, 0.08)',
                boxShadow: '0 50px 100px -20px rgba(0, 0, 0, 0.7)',
                borderRadius: '40px',
                zIndex: 1,
                position: 'relative',
                overflow: 'hidden',
                overflow: 'hidden'
            }}>
                {/* Luminous Tasarım Çizgisi (Üst) */}
                <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '120px',
                    height: '2px',
                    background: 'linear-gradient(90deg, transparent, #ffffff, transparent)',
                    boxShadow: '0 0 15px #ffffff'
                }}></div>

                <div className="text-center mb-xl">
                    <PlanZIcon size={72} style={{ margin: '0 auto 16px' }} />
                    <h1 style={{
                        color: '#ffffff',
                        fontSize: '32px',
                        fontWeight: '800',
                        marginBottom: '8px',
                        letterSpacing: '-1.5px',
                        textShadow: '0 0 20px rgba(255,255,255,0.1)'
                    }}>
                        plan<span style={{ color: '#F97316' }}>Z</span>
                    </h1>
                    <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', fontWeight: '500' }}>
                        Depo Rampa Rezervasyon Sistemi
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={{ marginBottom: '24px' }}>
                        <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1.5px' }}>E-posta Adresi</label>
                        <input
                            type="email"
                            className="input"
                            style={{
                                background: '#eef2f6', // Light background as per image
                                border: '2px solid transparent',
                                color: '#1a1a1a', // Dark text
                                borderRadius: '14px',
                                padding: '16px',
                                fontSize: '15px',
                                fontWeight: '600',
                                outline: 'none'
                            }}
                            placeholder="mail@antigravity.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group" style={{ marginBottom: '32px' }}>
                        <div className="flex justify-between items-center mb-sm">
                            <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 0 }}>Şifre</label>
                            <a href="#" style={{ color: '#ffffff', fontSize: '11px', fontWeight: '700', opacity: 0.6 }}>Şifremi Unuttum</a>
                        </div>
                        <input
                            type="password"
                            className="input"
                            style={{
                                background: '#eef2f6', // Light background
                                border: '2px solid transparent',
                                color: '#1a1a1a', // Dark text
                                borderRadius: '14px',
                                padding: '16px',
                                fontSize: '15px',
                                fontWeight: '600',
                                outline: 'none'
                            }}
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && (
                        <div className="form-error" style={{
                            background: 'rgba(239, 68, 68, 0.1)',
                            color: '#f87171',
                            padding: '12px',
                            borderRadius: '12px',
                            textAlign: 'center',
                            border: '1px solid rgba(239, 68, 68, 0.2)',
                            marginBottom: '20px',
                            fontSize: '13px'
                        }}>
                            {error}
                        </div>
                    )}

                    <div className="flex flex-col gap-md" style={{ width: '100%', alignItems: 'center' }}>
                        <Button
                            type="submit"
                            variant="primary"
                            loading={loading}
                            style={{
                                width: '100%',
                                padding: '18px',
                                borderRadius: '20px',
                                background: '#ffffff',
                                color: '#000000',
                                border: 'none',
                                fontWeight: '800',
                                fontSize: '16px',
                                boxShadow: '0 10px 20px rgba(255,255,255,0.1)'
                            }}
                        >
                            Giriş Yap
                        </Button>

                        <button
                            type="button"
                            onClick={() => navigate('/pricing')}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: 'rgba(255,255,255,0.4)',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                marginTop: '8px'
                            }}
                            onMouseOver={(e) => e.target.style.color = '#ffffff'}
                            onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.4)'}
                        >
                            Henüz hesabınız yok mu? <span style={{ color: '#ffffff', fontWeight: '800' }}>Yeni Üyelik</span>
                        </button>
                    </div>
                </form>

                {/* Alt Dekoratif Çizgi */}
                <div style={{
                    marginTop: '40px',
                    height: '1px',
                    width: '100%',
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)'
                }}></div>
            </div>
        </div>
    );
};

export default Login;
